import { Box, TableContainer } from '@mui/material';
import { useAppSelector } from '../../../../../hooks/reduxHooks';
import DataTable from '../../../../../components/DataTable/DataTable';
import { responsiblesTableColumnTitles } from '../consts';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import EyeIcon from '@mui/icons-material/Visibility';
import TableActionButton from '../../../../../components/DataTable/TableActionButton';
import { enqueueSnackbar } from 'notistack';

const ResponsiblesAccordionContent = ({
    responsibles,
    translate,
    handleClickEditIcon,
    responsiblesState,
    alerts,
    onlyVisual
}: any) => {
    const selectedCarcinogenicReportId = useAppSelector(
        (state) => state?.carcinogenicReport?.selectedCarcinogenicReportId
    );

    const { cargos, tiposContratacion, representaciones } = useAppSelector(
        (state) => state.datosParametricos.data
    );
    
    const getItemFromId = (id: number, array: any) => {
        const item = array?.find((item: any) => item.id === id);
        return item || '-';
    };


    const { deleteResponsible } = responsiblesState;

    const handleDeleteResponsible = async (contractorId: number) => {
        try {
            if (!contractorId || !selectedCarcinogenicReportId) return;
            const response = await responsiblesState.deleteResponsible({
                reportId: selectedCarcinogenicReportId,
                responsibleId: contractorId
            });
        } catch (error) {
            enqueueSnackbar(translate('enqueues.common.somethingWentWrong'), {
                variant: 'error'
            });
        }
    };

    const { showConfirmDeleteResponsibleAlert } = alerts;

    return (
        <>
            <TableContainer>
                <DataTable
                    // testID={TEST_IDS.table.id}
                    columnTitles={responsiblesTableColumnTitles(translate)}
                    columnWidths={[]}
                    onSelectRow={() => {}}
                    // selected={selected}
                    selectedItemFromAction={null}
                    menuOpen={false}
                    items={{ data: { data: responsibles } }}
                    loading={false}
                    filters={{ take: 1000, skip: 0 }}
                    setFilters={() => {}}
                    isFetching={false}
                    headers={[
                        {
                            type: 'data',
                            upperLabel: (item: any) =>
                                `${item?.nombre || ''} ${item?.apellido || ''}`
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) => {
                                const charge = getItemFromId(item?.idCargo, cargos);
                                return `${charge?.codigo || '-'}`;
                            }
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) => item?.cuit
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) => {
                                const representacion = getItemFromId(
                                    item?.idRepresentacion,
                                    representaciones
                                );
                                return `${representacion?.nombre || '-'}`;
                            }
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) => {
                                const tipoContratacion = getItemFromId(
                                    item?.idTipoContratacion,
                                    tiposContratacion
                                );
                                return `${tipoContratacion?.nombre || '-'}`;
                            }
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) => `${item?.titulo || '-'}`
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) => `${item?.matricula || '-'}`
                        },
                        {
                            type: 'data',
                            upperLabel: (item: any) => `${item?.entidadOtorgante || '-'}`
                        },
                        {
                            type: 'data',
                            lowerLabel: (item: any) => (
                                <Box display={'flex'} gap={1.5}>
                                    {!onlyVisual && (
                                        <TableActionButton
                                            disabled={false}
                                            onClick={() =>
                                                showConfirmDeleteResponsibleAlert({
                                                    confirmAction: () =>
                                                        handleDeleteResponsible(item?.id)
                                                })
                                            }
                                            IconComponent={DeleteIcon}
                                        />
                                    )}
                                    <TableActionButton
                                        disabled={false}
                                        onClick={() => handleClickEditIcon(item)}
                                        IconComponent={!onlyVisual ? EditIcon : EyeIcon}
                                    />
                                </Box>
                            )
                        }
                    ]}
                />
            </TableContainer>
        </>
    );
};

export { ResponsiblesAccordionContent };
